export default __webpack_public_path__ + "img/selection.asset.0d19580b.png";